import request from '../utils/request'

// ==================== 优惠券管理 ====================

// 获取优惠券列表
export function getCouponList(params) {
  return request({
    url: '/client.coupon_controller/list',
    method: 'get',
    params
  })
}

// 获取优惠券详情
export function getCouponDetail(id) {
  return request({
    url: '/client.coupon_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 创建优惠券
export function createCoupon(data) {
  return request({
    url: '/client.coupon_controller/create',
    method: 'post',
    data
  })
}

// 更新优惠券
export function updateCoupon(data) {
  return request({
    url: '/client.coupon_controller/update',
    method: 'post',
    data
  })
}

// 删除优惠券
export function deleteCoupon(id) {
  return request({
    url: '/client.coupon_controller/delete',
    method: 'post',
    data: { id }
  })
}

// 启用/禁用优惠券
export function changeCouponStatus(data) {
  return request({
    url: '/client.coupon_controller/changeStatus',
    method: 'post',
    data
  })
}

// 获取统计数据
export function getCouponStatistics() {
  return request({
    url: '/client.coupon_controller/statistics',
    method: 'get'
  })
}
